export default __webpack_public_path__ + "static/media/minigame_banner_3.6dc6d265.png";